export const printWarning = (message: unknown) => {
	if (
		typeof message === 'string' ||
		(typeof message === 'object' && message && typeof message.toString === 'function')
	) {
		console.warn(`[Smartsupp] ${message}`)
	}
}
